module.exports = __webpack_public_path__ + "static/media/optilase.0da5d2fc.jpg";